import { combineReducers } from '@reduxjs/toolkit';

import { sliceReducer } from '@modules/advancement/purchaseOrder/duck/slice';
import { ROUTE_PURCHASE_ORDER_DETAILS } from '@modules/shared';

import { cartStatusTypes, groupByFilter, typeFilter } from '../constants';
import {
  ADD_ITEMS_TO_CART_ERROR,
  ADD_ITEMS_TO_CART_REQUEST,
  ADD_ITEMS_TO_CART_RESPONSE,
  CREATE_PURCHASE_ORDER_RESPONSE,
  DELETE_FROM_ORDER_AND_RETRY,
  FETCH_ALL_PURCHASE_ORDERS_RESPONSE,
  FETCH_DETAILS_AND_RETRY_REQUEST,
  FETCH_PURCHASE_ORDER_DETAILS_REQUEST,
  FETCH_PURCHASE_ORDER_DETAILS_RESPONSE,
  HIDE_ADD_ITEMS_MODAL,
  HIDE_ADD_TO_CART_MODAL,
  HIDE_CLOSED_PO_MODAL,
  SET_CART_TOKEN,
  SET_PO_SECTION_EXPANDED,
  SET_PURCHASE_ORDER_DETAILS_FILTER,
  SET_PURCHASE_ORDER_LOADING,
  SHOW_ADD_ITEMS_MODAL,
  SHOW_ADD_TO_CART_MODAL,
  SHOW_CLOSED_PO_MODAL,
} from './actions';
import { SET_SELECTED_ROW_KEYS_TO_PURCHASE } from './actionsTyped';

const closedPOModalVisible = (state = false, { type }) => {
  switch (type) {
    case SHOW_CLOSED_PO_MODAL: {
      return true;
    }
    case HIDE_CLOSED_PO_MODAL: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const addToCartModalVisible = (state = false, { type }) => {
  switch (type) {
    case SHOW_ADD_TO_CART_MODAL: {
      return true;
    }
    case HIDE_ADD_TO_CART_MODAL: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const addItemsModalVisible = (state = false, { type }) => {
  switch (type) {
    case SHOW_ADD_ITEMS_MODAL: {
      return true;
    }
    case HIDE_ADD_ITEMS_MODAL: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const cartStatus = (state = cartStatusTypes.REVIEWING, { type }) => {
  switch (type) {
    case DELETE_FROM_ORDER_AND_RETRY:
    case ADD_ITEMS_TO_CART_REQUEST: {
      return cartStatusTypes.REVIEWING;
    }
    case ADD_ITEMS_TO_CART_RESPONSE: {
      return cartStatusTypes.AVAILABLE;
    }
    case ADD_ITEMS_TO_CART_ERROR: {
      return cartStatusTypes.ERROR;
    }
    default: {
      return state;
    }
  }
};

const cartToken = (state = null, { type, payload }) => {
  switch (type) {
    case SET_CART_TOKEN: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const cartProblems = (state = [], { type, payload }) => {
  switch (type) {
    case ADD_ITEMS_TO_CART_ERROR: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const allPurchaseOrders = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_ALL_PURCHASE_ORDERS_RESPONSE: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const currentPurchaseOrderDetails = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_PURCHASE_ORDER_DETAILS_RESPONSE: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const currentPurchaseOrderDetailsLoading = (state = false, { type }) => {
  switch (type) {
    case FETCH_DETAILS_AND_RETRY_REQUEST:
    case FETCH_PURCHASE_ORDER_DETAILS_REQUEST: {
      return true;
    }
    case FETCH_PURCHASE_ORDER_DETAILS_RESPONSE: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const selectedPurchaseOrderId = (state = {}, { type, payload }) => {
  switch (type) {
    case CREATE_PURCHASE_ORDER_RESPONSE: {
      return payload.id;
    }
    case ROUTE_PURCHASE_ORDER_DETAILS: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const createPurchaseOrderLoading = (state = false, { type, payload }) => {
  switch (type) {
    case SET_PURCHASE_ORDER_LOADING: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const defaultFilter = {
  [typeFilter.SKU]: true,
  [typeFilter.PRICES]: true,
  [typeFilter.NOTES]: true,
  [groupByFilter.NO_GROUPING]: true,
  [groupByFilter.ITEM_TYPE]: false,
  [groupByFilter.YOUTH]: false,
  [groupByFilter.SUB_UNIT]: false,
};

const filterPODetails = (state = defaultFilter, { type, payload }) => {
  switch (type) {
    case SET_PURCHASE_ORDER_DETAILS_FILTER: {
      return payload;
    }
    default: {
      return state;
    }
  }
};

const selectedRowKeysToPurchase = (state = [], { type, payload }) => {
  switch (type) {
    case SET_SELECTED_ROW_KEYS_TO_PURCHASE:
      return payload;
    default: {
      return state;
    }
  }
};

const poSectionExpanded = (state = {}, { type, payload }) => {
  switch (type) {
    case SET_PO_SECTION_EXPANDED: {
      return { ...state, ...payload };
    }
    default: {
      return state;
    }
  }
};

const reducers = combineReducers({
  closedPOModalVisible,
  addToCartModalVisible,
  addItemsModalVisible,
  cartStatus,
  cartToken,
  allPurchaseOrders,
  currentPurchaseOrderDetails,
  currentPurchaseOrderDetailsLoading,
  selectedPurchaseOrderId,
  cartProblems,
  createPurchaseOrderLoading,
  filterPODetails,
  selectedRowKeysToPurchase,
  poSectionExpanded,
  sliceReducer,
});

export default reducers;
